import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import '../../assets/css/admin/allcourses.css';
import Swal from 'sweetalert2';
import axios from 'axios';

const AllTuitions = () => {
    const [tuitions, setTuitions] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredTuitions, setFilteredTuitions] = useState([]);

    useEffect(() => {
        fetchTuitions();
    }, []);

    // Real-time filtering effect
    useEffect(() => {
        if (searchTerm.trim() === '') {
            setFilteredTuitions(tuitions);
        } else {
            const results = tuitions.filter((tuition) =>
                (tuition.className && tuition.className.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (tuition.subject && tuition.subject.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (tuition.teacherName && tuition.teacherName.toLowerCase().includes(searchTerm.toLowerCase()))
            );
            setFilteredTuitions(results);
        }
    }, [searchTerm, tuitions]);

    const fetchTuitions = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/tuition/all');
            const data = await response.json();
            setTuitions(data);
            setFilteredTuitions(data); // Initialize filteredTuitions with all tuitions
        } catch (error) {
            console.error('Error fetching tuitions:', error);
        }
    };

    const handleDelete = (tuitionId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete this tuition?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post(`https://api.myskills.lk/tuition/delete/${tuitionId}`)
                    .then((response) => {
                        // Update local state after successful deletion
                        const updatedTuitions = tuitions.filter(tuition => tuition.id !== tuitionId);
                        setTuitions(updatedTuitions);
                        setFilteredTuitions(updatedTuitions);
                        
                        // Show success message
                        Swal.fire({
                            title: "Deleted!",
                            text: "The tuition has been deleted.",
                            icon: "success"
                        });
                    })
                    .catch((err) => {
                        console.error("Error deleting tuition:", err);
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to delete the tuition.",
                            icon: "error"
                        });
                    });
            }
        });
    };

        // const handleEdit = (tuitionId) => {
    //     // Navigate to edit page or show edit form in place
    //     // For example, navigate to `/edit-tuition/${tuitionId}` or show form inline
    //     console.log('Edit course with ID:', tuitionId);
    // };


    return (
        <div>
            <AdminDashboard />

            <div className='AllViews-admin-course'>
                <div className="search-icon-admin admin-course-search">
                    <h1>ALL TUITIONS</h1>
                    <form onSubmit={(e) => e.preventDefault()}>
                        <input 
                            type="text" 
                            placeholder='Search Item' 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <input type="submit" value="SEARCH" />
                    </form>
                </div>

                <div className="scroller-box">
                    <div className="table-course">
                    <table>
                            <thead>
                                <tr>
                                    <th>Class Name</th>
                                    <th>Subject</th>
                                    <th>Teacher Name</th>
                                    <th>Start Date</th>
                                    <th>Time</th>
                                    <th>Contact</th>
                                    <th>Email</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredTuitions.length > 0 ? (
                                    filteredTuitions.map((tuition) => (
                                        <tr key={tuition.id}>
                                            <td>{tuition.className}</td>
                                            <td>{tuition.subject}</td>
                                            <td>{tuition.teacherName}</td>
                                            <td>{new Date(tuition.startDate).toLocaleDateString('en-CA')}</td>
                                            <td>{new Date(`1970-01-01T${tuition.time}Z`).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</td>
                                            <td>{tuition.contact}</td>
                                            <td>{tuition.teacherEmail}</td>
                                            <td>
                                                {tuition.website ? (
                                                    <a href={tuition.website} target="_blank" rel="noopener noreferrer" id='view-website'>WEBSITE</a>
                                                ) : (
                                                    <span style={{ color: '#999' }}>No Website</span>
                                                )}
                                            </td>
                                            <td id='action-buttons'>
                                                {/* <a href="#!" id='man-details' onClick={() => handleEdit(course.id)}>EDIT</a> */}
                                                <a href="#!" id='del-details' onClick={(e) => handleDelete(tuition.id)}>DELETE</a>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="9" style={{ textAlign: 'center' }}>No tuitions found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table> 
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllTuitions;
